const getters = {
	getGuestCart(state) {
    return state.guestCart
  },
  getUserCart(state) {
    return state.userCart
  }
}

export default getters
